import React from 'react'
import { generatePath } from 'react-router'

import { useListRequest, useRequest } from '../hooks/request'
import { PATHS } from '../constants/paths'
import { internshipList, internshipDelete } from '../requests/internship'
import { getFullName } from '../utils/getFullName'
import { ROLES, ROLES_BO_EVAL } from '../constants/roles'
import { useUser } from '../data/UserContext'
import { useGenericStorage } from '../data/GenericStorageContext'
import { history } from '../utils/history'
import { createDuplicateName } from '../utils/createDuplicateName'
import { grantAccess } from '../utils/grantAccess'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { HiddenListButtonWrapper, List, ListButtonWrapper } from './common/List'
import { DeleteButton } from './common/ConfirmButton'
import {
  DummyButton, EditButton, GoToItemCreate, GreenButton,
} from './common/Button'
import { Authorize } from './common/Authorize'
import { Margin } from './common/Margin'
import { Duplicate } from './icons/Duplicate'
import { SearchCreateWrapper } from './common/SearchCreateWrapper'


const getTitles = ({ user }) => {
  const titles = [
    { title: 'name' },
    { title: 'role.INTERNSHIP_MASTER' },
    { title: 'deputy' },
    { title: 'traineesNumber' },
  ]
  if (grantAccess({
    user,
    roles: ROLES_BO_EVAL,
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  })) {
    titles.push({
      size: 0,
      content: (
        <HiddenListButtonWrapper>
          <Authorize roles={ROLES_BO_EVAL} isInternshipDirector>
            <DummyButton />
            <Margin h={10} />
          </Authorize>
          <DummyButton />
          <Authorize roles={ROLES_BO_EVAL} isInternshipDirector>
            <Margin h={10} />
            <DummyButton />
          </Authorize>
        </HiddenListButtonWrapper>
      ),
    })
  }

  return titles
}

const displayItem = (item, props) => {
  const cells = [
    item.name,
    { content: item.chief && getFullName({ user: item.chief }) },
    { content: item.deputies && item.deputies[0] && getFullName({ user: item.deputies[0] }) },
    item.trainees?.length || 0,
  ]
  if (grantAccess({
    user: props.user,
    roles: [ROLES.INTERNSHIP_DIRECTOR],
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  })) {
    cells.push({
      content: (
        <ListButtonWrapper>
          <Authorize roles={ROLES_BO_EVAL} isInternshipDirector>
            <GreenButton
              icon={<Duplicate />}
              onClick={() => {
              // for some reason react-router state didnt work, so had to do that
                props.setInternshipToDuplicate(item)
                history.push(PATHS.INTERNSHIP_CREATE)
              }}
            />
            <Margin h={10} />
          </Authorize>
          <EditButton
            to={generatePath(PATHS.INTERNSHIP_EDIT, { id: item.id })}
          />
          <Authorize roles={ROLES_BO_EVAL} isInternshipDirector>
            <Margin h={10} />
            <DeleteButton
              loading={props.deletingId === item.id}
              titleTrad="confirmDeleteInternship"
              onConfirm={() => props.onConfirmDelete({ id: item.id })}
            />
          </Authorize>

        </ListButtonWrapper>
      ),
    })
  }

  return cells
}

export const InternshipList = () => {
  const { user } = useUser()
  const { mergeIntoGenericStorage } = useGenericStorage()
  const setInternshipToDuplicate = (i) => mergeIntoGenericStorage({
    internshipToDuplicate: createDuplicateName({ item: i }),
  })
  const internshipListRequest = useListRequest({
    start: true,
    shouldFilter: true,
    request: internshipList,
  })

  const internshipDeleteRequest = useRequest({
    request: internshipDelete,
    handler: (p) => p.then(internshipListRequest.fetch),
  })

  const titles = getTitles({ user })

  return (
    <>
      <PageTitle tradId="internshipList" />
      <PageContent>
        <Authorize roles={ROLES_BO_EVAL} isInternshipDirector>
          <SearchCreateWrapper>
            <GoToItemCreate
              tradId="internshipCreate"
              to={PATHS.INTERNSHIP_CREATE}
            />
          </SearchCreateWrapper>
          <Margin v={10} />
        </Authorize>
        <List
          onConfirmDelete={internshipDeleteRequest.fetch}
          user={user}
          setInternshipToDuplicate={setInternshipToDuplicate}
          deletingId={internshipDeleteRequest.state.params?.id}
          listRequest={internshipListRequest}
          columnTitles={titles}
          displayItem={displayItem}
        />
      </PageContent>
    </>
  )
}
